import { FrontendEnvironmentSettings } from '@act/shared/environment';
import { apiDomain as localApiDomain } from './local-api-domain';

const clientHost = window.location.origin;

// replace "/care." or "/consent." with "/api."
let calculatedDomain = clientHost.replace(/\/care\.|\/consent\./, '/api.');

// If in development then use apiDomain from local-api-domain.ts
if (import.meta.env.DEV) {
  calculatedDomain = localApiDomain;
}

export const apiDomain = calculatedDomain;

export const environmentOverride: Partial<FrontendEnvironmentSettings> = {};
